var _rect, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgChangeToChart = function SvgChangeToChart(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_745_905",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_745_905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16V10.1333H10.5238V16H9ZM11.7937 16V8H13.3175V16H11.7937ZM14.5873 16V12.2667H16.1111V16H14.5873Z",
    fill: "#DCC6B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C10.1333 23 8.41667 22.575 6.85 21.725C5.28333 20.875 4 19.7417 3 18.325V21H1V15H7V17H4.525C5.325 18.2 6.37933 19.1667 7.688 19.9C8.996 20.6333 10.4333 21 12 21C13.25 21 14.421 20.7627 15.513 20.288C16.6043 19.8127 17.5543 19.1707 18.363 18.362C19.171 17.554 19.8127 16.604 20.288 15.512C20.7627 14.4207 21 13.25 21 12H23C23 13.5167 22.7127 14.9417 22.138 16.275C21.5627 17.6083 20.775 18.775 19.775 19.775C18.775 20.775 17.6083 21.5623 16.275 22.137C14.9417 22.7123 13.5167 23 12 23ZM1 12C1 10.4833 1.28767 9.05833 1.863 7.725C2.43767 6.39167 3.225 5.225 4.225 4.225C5.225 3.225 6.39167 2.43733 7.725 1.862C9.05833 1.28733 10.4833 1 12 1C13.8667 1 15.5833 1.425 17.15 2.275C18.7167 3.125 20 4.25833 21 5.675V3H23V9H17V7H19.475C18.675 5.8 17.6207 4.83333 16.312 4.1C15.004 3.36667 13.5667 3 12 3C10.75 3 9.57933 3.23733 8.488 3.712C7.396 4.18733 6.446 4.829 5.638 5.637C4.82933 6.44567 4.18733 7.39567 3.712 8.487C3.23733 9.579 3 10.75 3 12H1Z",
    fill: "#DCC6B7"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangeToChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ChangeToChart.8c5d59cc.svg";
export { ForwardRef as ReactComponent };